import React, {useState} from 'react';
import {Box, Columns, Modal} from 'react-bulma-components';
import transactionService, {Transaction} from '../services/transaction/transaction.service';
import TransactionForm from '../components/TransactionForm';

const InitiateTransactionPage: React.FC = () => {
  const [openAppPageRawHTML, setOpenAppPageRawHTML] = useState<string | null>();
  const [isLoading, setIsLoading] = useState(false);
  const [txStatus, setTxStatus] = useState<string | null>();

  const initiateTransaction = async (transaction: Transaction): Promise<void> => {
    setIsLoading(true);
    setTxStatus(null);

    try {
      const {acsTransID, acsURL} = await transactionService.initiateTransaction(transaction);

      const body = await transactionService.startChallengeRequest(acsURL, acsTransID);
      setOpenAppPageRawHTML(body);

      const onMessagePosted = async (e: MessageEvent): Promise<void> => {
        if (e.data === '3DS-authentication-complete') {
          setOpenAppPageRawHTML(null);

          const {status} = await transactionService.getTransactionStatus(acsTransID);
          setTxStatus(status);

          window.removeEventListener('message', onMessagePosted);
        }
      };

      window.addEventListener('message', onMessagePosted, false);
    } catch {
      setTxStatus('approval_failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Columns>
        <Columns.Column
          size={6}
          offset={3}
          mobile={{size: 12}}
        >
          <Box className="mx-2">
            <h1 className="is-size-3 mb-4 form-header">
              <span>Demo Checkout</span>

              {txStatus === 'pending' && (<span>⏳ Pending</span>)}
              {txStatus === 'rejected' && (<span>❌ Not Approved</span>)}
              {txStatus === 'approval_failed' && (<span>❌ Approval Failed</span>)}
              {txStatus === 'approved' && (<span>✅ Approved</span>)}
            </h1>

            <TransactionForm
              isLoading={isLoading}
              onSubmitted={initiateTransaction}
            />
          </Box>
        </Columns.Column>
      </Columns>

      <Modal
        show={openAppPageRawHTML != null}
        onClose={() => setOpenAppPageRawHTML(null)}
      >
        <Modal.Card>
          <Modal.Card.Header showClose={true}>
            <Modal.Card.Title />
          </Modal.Card.Header>
          <Modal.Card.Body style={{
            paddingTop: '0px',
            paddingRight: '40px',
            paddingBottom: '60px',
            paddingLeft: '40px',
          }}
          >
            <iframe
              width='100%'
              style={{height: '250px'}}
              src={`data:text/html;charset=utf-8,${escape(openAppPageRawHTML!)}`}
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-forms allow-top-navigation"
            />
          </Modal.Card.Body>
        </Modal.Card>
      </Modal>
    </>
  );
};

export default InitiateTransactionPage;
